import React from 'react';
import { Pagination as AntPagination, Row, Col } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import PageSizeSelect from './PageSizeSelect';
const PaginationContainer = styled.div `
  padding: 16px 32px;
`;
const getNumberOfElements = (pageNumber, pageSize, totalRecords) => ({
    start: (pageNumber - 1) * pageSize + 1,
    end: pageNumber * pageSize > totalRecords ? totalRecords : pageNumber * pageSize,
    totalRecords: totalRecords
});
const Pagination = ({ totalRecords, pageSize, pageNumber, isDisabled, onPageNumberChange, onPageSizeChange }) => {
    const { t: translate } = useTranslation();
    if (totalRecords === 0)
        return null;
    return (<PaginationContainer>
      <Row>
        <Col flex={20}>
          <AntPagination size='small' hideOnSinglePage total={totalRecords} onChange={onPageNumberChange} current={pageNumber} pageSize={pageSize} showSizeChanger={false} disabled={isDisabled}/>
        </Col>
        <Col flex={2} style={{ textAlign: 'center' }}>
          <PageSizeSelect onPageSizeChange={onPageSizeChange} totalRecords={totalRecords} selectedValue={pageSize} isDisabled={isDisabled}/>
        </Col>
        <Col flex={2} style={{ textAlign: 'right' }}>
          {translate('PAGINATION.NUMBER_OF_ELEMENTS', getNumberOfElements(pageNumber, pageSize, totalRecords))}
        </Col>
      </Row>
    </PaginationContainer>);
};
export default Pagination;
